import { jwtDecode } from "jwt-decode";

class TokenParser {

    static parseScopes(token) {
        if (!token) return [];
        try {
            const decoded = jwtDecode(token);
            const scopes = decoded.scope ? decoded.scope.split(" ").map((s) => s.trim()) : [];
            console.log("Parsed scopes:", scopes);
            return scopes;
        } catch (error) {
            console.error("Failed to decode token:", error);
            return [];
        }
    }


    static hasScope(token, requiredScope) {
        const scopes = this.parseScopes(token);
        return scopes.includes(requiredScope);
    }
}

export default TokenParser;
